import { render, staticRenderFns } from "./EmailUnsubscribe.vue?vue&type=template&id=bc02cc00&scoped=true"
import script from "./EmailUnsubscribe.vue?vue&type=script&lang=js"
export * from "./EmailUnsubscribe.vue?vue&type=script&lang=js"
import style0 from "./EmailUnsubscribe.vue?vue&type=style&index=0&id=bc02cc00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc02cc00",
  null
  
)

export default component.exports